export enum ELEMENT_SIZE {
	SM = "sm",
	LG = "lg",
	XL = "xl"
}
